import { render } from "./CompetitionModal.vue?vue&type=template&id=1330e21e&scoped=true"
import script from "./CompetitionModal.vue?vue&type=script&lang=js"
export * from "./CompetitionModal.vue?vue&type=script&lang=js"

import "./CompetitionModal.vue?vue&type=style&index=0&id=1330e21e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1330e21e"]])

export default __exports__